import { AES, enc } from 'crypto-js';
import { ENVIRONMENT_CONFIG } from '../constants/environmentConfig';

const SECRET_KEY = ENVIRONMENT_CONFIG.ENCRYPTION_KEY;

export const encryptData = (data: any) => {
  return AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
};

export const decryptData = (ciphertext: string) => {
  try {
    const bytes = AES.decrypt(ciphertext, SECRET_KEY);
    return JSON.parse(bytes.toString(enc.Utf8));
  } catch (error) {
    console.error('Decryption failed:', error);
    return null;
  }
};
